import { TRIGGER_MANAGED_EXPORT_RIGHT_SIDE_UPDATE, STOP_MANAGED_EXPORT_RIGHT_SIDE_UPDATE } from '../actions/actionTypes';

export const triggerReducer = (state: boolean = false, action: any) => {

  switch (action.type) {
    case TRIGGER_MANAGED_EXPORT_RIGHT_SIDE_UPDATE:
      return state = true;
    case STOP_MANAGED_EXPORT_RIGHT_SIDE_UPDATE:
      return state = false;
    default:
     return state;
  };
};
